<!-- Backdrop -->
@if (isNotificationOpen) {
  <div class="backdrop" (click)="closePanel()"></div>
}

<!-- Slide-in Panel -->
<div class="panel" [class.open]="isNotificationOpen">
  <div class="sticky-container">
    <div class="panel-header">
      <h3 class="panel-title">Notifications</h3>
      <div class="header-actions">
        <button class="close-btn" (click)="closePanel()">✕</button>
      </div>
    </div>
  </div>
  @if (allNotifications.length > 0) {
    <button class="clear-all" (click)="clearAll()">Clear All</button>
  }
  <div class="panel-content">
    @if (allNotifications.length > 0) {
      @for (notification of allNotifications; track $index) {
        <app-single-notification
          class="single-notification"
          [notification]="notification"
        />
      }
    } @else {
      <div class="no-notifications">No notifications</div>
    }
  </div>
</div>
